// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Zi_r","colCheckbox":"styles_colCheckbox__11lja"};